module.exports = __webpack_public_path__ + "static/business-handshake-min.469d1bf0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/universal/img/business-handshake-min.jpg
// module id = 825
// module chunks = 168707334958949